// /politica-de-privacidad — SSR head()
import { createFileRoute } from "@tanstack/react-router";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import { buildStaticHead, staticLoader, type StaticSEO } from "@/lib/static-route-seo";

const SEO: StaticSEO = {
  es: {
    title: "Política de Privacidad | Fora da Rota",
    description:
      "Cómo Fora da Rota recopila, usa y protege tus datos personales. Consulta nuestra política de privacidad completa.",
  },
  "pt-BR": {
    title: "Política de Privacidade | Fora da Rota",
    description:
      "Como a Fora da Rota coleta, usa e protege seus dados pessoais. Consulte nossa política de privacidade completa.",
  },
  en: {
    title: "Privacy Policy | Fora da Rota",
    description:
      "How Fora da Rota collects, uses and protects your personal data. Read our full privacy policy.",
  },
  "en-EU": {
    title: "Privacy Policy | Fora da Rota",
    description:
      "How Fora da Rota collects, uses and protects your personal data. Read our full privacy policy.",
  },
};

export const Route = createFileRoute("/politica-de-privacidad")({
  loader: staticLoader,
  head: ({ loaderData }) =>
    buildStaticHead(SEO, "/politica-de-privacidad", loaderData),
  component: PrivacyPolicy,
});
